import { ContentElement } from "./components/Elements/Content";
import { ScriptElement } from "./components/Elements/Script";
import { StepRenderer } from "./components/StepRenderer";
import { FormStep } from "./components/Steps/FormStep";
import { FormSkeleton } from "./components/Skeleton/FormSkeleton";
import { QuestionSkeleton } from "./components/Skeleton/QuestionSkeleton";
import { ContentStep } from "./components/Steps/ContentStep";
import { Content } from "./components/Fields/Content";

export const UI = {
  StepRenderer,
  FormStep,
  FormSkeleton,
  QuestionSkeleton,
  ContentElement,
  ScriptElement,
  ContentStep,
  ContentField: Content,
};

export { getAvailableCountries, getCountries, getCountryCallingCode } from "./utils/phoneCountries";
export type { CountryOption } from "./utils/phoneCountries";
export { getCurrencySymbol, getCommonCurrencies, formatCurrency } from "./utils/currencyUtils";